import { useCallback, useMemo } from 'react'

import * as Analytics from 'analytics/analytics'

import CategoryTile from 'LuxKit/CategoryTile'
import styled from 'styled-components'
import { rem } from 'polished'

interface Props {
  category: App.Tours.CategoryData
  actionText: string
  onClick?: () => void
  toUrl?: string
}

const CategoryTourWrapper = styled(CategoryTile)`
  width: ${rem(180)};
`

function TourPageCategoryTile(props: Props) {
  const { category, actionText, toUrl, onClick } = props

  const image = useMemo((): App.Image => ({
    id: category.imageId,
    title: category.name,
  }), [category])

  const handleClick = useCallback(() => {
    onClick?.()
    Analytics.trackClientEvent({
      action: 'pressed',
      subject: `tour_explore_category_${category.name.toLowerCase().replaceAll(' ', '_')}`,
      category: 'vertical_page',
      type: 'interaction',
    })
  }, [category.name, onClick])

  return <CategoryTourWrapper
    onClick={handleClick}
    to={toUrl}
    image={image}
    heading={category.name}
    subHeading={category.subText}
    align="top"
    callToAction={actionText}
  />
}

export default TourPageCategoryTile
